import URL from 'Constants/apiUrls'
import api from 'Services/api-call'

const facilities = {
  branch: {
    get: payload => api(`${URL.facilities.branch.getAll}`, payload, true),
    create: payload => api(`${URL.facilities.branch.create}`, payload, true),
  },
  company: {
    get: payload => api(`${URL.facilities.company.getAll}`, payload, true),
    create: payload => api(`${URL.facilities.company.create}`, payload, true),
    getAllClientCompanyListForUser: () => api(`${URL.facilities.company.getAllClientCompanyListForUser}`),
  },
  site: {
    create: payload => api(`${URL.facilities.site.create}`, payload, true),
    uploadPhoto: payload => api(`${URL.facilities.site.uploadPhoto}`, payload, true),
  },
  getUserSitesAndRoles: id => api(`${URL.facilities.getUserSitesAndRoles}/${id}`),
  addUpdateCompanyBranch: payload => api(`${URL.facilities.addUpdateCompanyBranch}`, payload, true),
  addUpdateSiteContact: payload => api(`${URL.facilities.addUpdateSiteContact}`, payload, true),
  getAllSiteContacts: payload => api(`${URL.facilities.getAllSiteContacts}`, payload, true),
  deleteSiteContact: id => api(`${URL.facilities.deleteSiteContact}/${id}`),
  getAllStateList: payload => api(`${URL.facilities.getAllStateList}`, payload, true),
  getAllWorkOrdersByClientCompanyId: payload => api(`${URL.facilities.getAllWorkOrdersByClientCompanyId}`, payload, true),
  getAllSiteListForBranches: payload => api(`${URL.facilities.getAllSiteListForBranches}`, payload, true),
  getAllBranchWithClientCompanyAndSites: () => api(`${URL.facilities.getAllBranchWithClientCompanyAndSites}`),
}

export default facilities
